import { useState, useEffect, useRef } from "react";

function useInView() {
  const ref = useRef(null);
  const [visible, setVisible] = useState(false);
  useEffect(() => {
    const obs = new IntersectionObserver(([e]) => { if (e.isIntersecting) setVisible(true); }, { threshold: 0.1 });
    const el = ref.current;
    if (el) obs.observe(el);
    return () => { if (el) obs.unobserve(el); };
  }, []);
  return [ref, visible];
}

function Reveal({ children, delay = 0, style = {}, className = "" }) {
  const [ref, visible] = useInView();
  return (
    <div ref={ref} className={className} style={{
      opacity: visible ? 1 : 0,
      transform: visible ? "translateY(0px)" : "translateY(15px)",
      transition: `opacity 0.8s cubic-bezier(0.16, 1, 0.3, 1) ${delay}s, transform 0.8s cubic-bezier(0.16, 1, 0.3, 1) ${delay}s`,
      ...style,
    }}>
      {children}
    </div>
  );
}

export default function SunEntrepreneursLife() {
  return (
    <>
      <style>{`
        @import url('https://fonts.googleapis.com/css2?family=Montserrat:wght@400;500;600;700;800;900&family=Plus+Jakarta+Sans:wght@400;500;600;700;800&display=swap');

        .life-page {
          background-color: #ffffff;
          color: #1a1a1a;
          font-family: 'Plus Jakarta Sans', sans-serif;
          line-height: 1.6;
          min-height: 100vh;
          padding-bottom: 80px;
        }

        .hero-section {
          background: #ffffff;
          padding: 80px 20px 40px;
          text-align: center;
          border-bottom: 1px solid #eee;
        }

        .hero-title {
          font-family: 'Montserrat', sans-serif;
          font-size: clamp(40px, 8vw, 64px);
          font-weight: 800;
          text-transform: lowercase;
          margin-bottom: 8px;
          color: #111;
          letter-spacing: -2px;
        }

        .hero-subtitle {
          font-size: clamp(18px, 3vw, 24px);
          font-weight: 700;
          color: #006600;
          opacity: 1;
          letter-spacing: 0.5px;
        }

        .life-body {
          max-width: 900px;
          margin: 60px auto 0;
          padding: 0 40px;
        }

        .content-points {
          display: grid;
          gap: 24px;
        }

        .point {
          font-size: 18px;
          color: #333;
          font-weight: 500;
          line-height: 1.7;
          border-left: 4px solid #006600;
          padding-left: 20px;
          transition: transform 0.3s;
        }

        .point:hover {
          transform: translateX(10px);
          color: #000;
        }

        .rewards-highlight {
          margin-top: 50px;
          background: #f9f9f9;
          padding: 40px;
          border-radius: 16px;
          border-left: 5px solid #f1c40f;
        }

        .rewards-title {
          font-size: 20px;
          font-weight: 800;
          color: #f1c40f;
          margin-bottom: 12px;
        }

        .gold-silver {
          font-size: 24px;
          font-weight: 800;
          color: #f1c40f;
          display: inline-block;
          margin: 0 5px;
        }

        .closing-text {
          margin-top: 60px;
          text-align: center;
          font-size: 20px;
          font-weight: 600;
          color: #f1c40f;
        }

        @media (max-width: 768px) {
          .life-body { padding: 40px 24px; margin: -40px 16px 40px; }
          .point { font-size: 16px; }
        }
      `}</style>

      <div className="life-page">
        <section className="hero-section">
          <div className="hero-content">
            <Reveal><h1 className="hero-title">SUN DISTRIBUTORS</h1></Reveal>
            <Reveal delay={0.1}><p className="hero-subtitle">Change Your Thought, Change Your Life</p></Reveal>
            <Reveal delay={0.2}><div style={{ fontSize: '20px', fontWeight: 800, color: '#006600', marginTop: '10px' }}>SUN DISTRIBUTORS LIFE</div></Reveal>
          </div>
        </section>

        <div className="life-body">
          <div className="content-points">
            <Reveal delay={0.2}><div className="point">At SUN DISTRIBUTORS, we believe that true success begins with learning and self-development.</div></Reveal>
            <Reveal delay={0.25}><div className="point">Through our free franchise program, anyone can start their journey from zero investment.</div></Reveal>
            <Reveal delay={0.3}><div className="point">Every partner receives 100 days of business training to master real-life entrepreneurship skills.</div></Reveal>
            <Reveal delay={0.35}><div className="point">From marketing to leadership, we teach how to grow step by step in every business category.</div></Reveal>
            <Reveal delay={0.4}><div className="point">With dedication and teamwork, you can transform your ideas into powerful income sources.</div></Reveal>
            <Reveal delay={0.45}><div className="point">SUN DISTRIBUTORS Life helps you earn through retail profit, referral income, and team bonuses.</div></Reveal>
          </div>

          <Reveal delay={0.5}>
            <div className="rewards-highlight">
              <div className="rewards-title">Luxury Rewards Await You</div>
              <p>As you grow, you also qualify for premium rewards — 
                <span className="gold-silver">Gold, Silver, Car, House & Tours</span>.
              </p>
            </div>
          </Reveal>

          <Reveal delay={0.6}>
            <div className="closing-text">
              Start today, learn continuously, and let SUN DISTRIBUTORS Life turn your dreams into reality.
            </div>
          </Reveal>
        </div>
      </div>
    </>
  );
}
